module.exports = __webpack_public_path__ + "img/38.531bbccc.jpg";